import { useReducer } from "react";
import SendOtpForm from "@/pages/auth/otp/_components/send-otp-form.component";
import otpReducer, { otpState } from "./otp-reducer";
import VerifyOtpForm from "@/pages/auth/otp/_components/verify-otp-form.component";
import AuthLogo from "../_components/auth-logo.component";

const Otp = () => {
  const initialState: otpState = {
    step: "send",
    timer: 0,
  };

  const [{ phoneNumber, timer, step }, dispatch] = useReducer(
    otpReducer,
    initialState
  );

  return (
    <div className="w-full px-[15px] pt-[96px] pb-8 max-w-md mx-auto shadow-none border-0">
      <AuthLogo wrapperClasses="mb-[54px]" />
      
      {step === "send" ? (
        <SendOtpForm
          phoneNumber={phoneNumber}
          timer={timer}
          dispatch={dispatch}
        />
      ) : (
        <VerifyOtpForm
          phoneNumber={phoneNumber}
          timer={timer}
          dispatch={dispatch}
        />
      )}
    </div>
  );
};

export default Otp;
